import ClayForm from "@clayui/form";
import ClayLayout from "@clayui/layout";
import { IconInputboxComponent } from 'common-ui-modules';
import { Formik } from "formik";
import React, { useEffect } from 'react';
const BitnamiHomeSearch = ({ fetchAppsPayload, setFetchAppsPayload }) => {
    const handleSubmit = (values) => {
        setFetchAppsPayload({ ...fetchAppsPayload, searchText: values.searchText });
    };
    return (
        <Formik
            destroyOnUnmount={false}
            onSubmit={handleSubmit}
            initialValues={{ searchText: '' }}
        >
            {(formik) => {
                useEffect(() => {
                    if (fetchAppsPayload.searchText === '') {
                        formik?.setFieldValue('searchText', '');
                    }
                }, [fetchAppsPayload.searchText]);

                return (
                    <ClayLayout.Row className='mr-1 mb-3'>
                        <ClayLayout.Col className='bitnami-search-box' >
                            <ClayForm onSubmit={formik.handleSubmit} noValidate>
                                <IconInputboxComponent
                                    placeholder='Search Application...'
                                    value={formik.values.searchText}
                                    onChange={(e) =>
                                        formik?.setFieldValue('searchText', e.target.value)
                                    }
                                    showCrossIcon={true}
                                    crossClick={(e) => {
                                        formik?.setFieldValue('searchText', '');
                                        handleSubmit({ searchText: '' });
                                    }}
                                />
                            </ClayForm>
                        </ClayLayout.Col>
                    </ClayLayout.Row>
                );
            }}
        </Formik>
    );
};

export default BitnamiHomeSearch;